import Vue from 'vue';
import { mapActions } from 'vuex';

const withFormParams = (component) => {
  return Vue.component('WithFormParams', {
    data: () => ({
      params: undefined,
      isLoading: false,
      dataLoaded: false,
      error: '',
    }),
    computed: {
      campaignSlug() {
        return this.$route.params.campaign_slug;
      },
    },
    mounted() {
      this.isLoading = true;
      this.setCampaignSlug(this.campaignSlug);
      this.$axios.api
        .get(`form/${this.campaignSlug}`)
        .then((response) => {
          const params = response.data;
          this.setParams(params);
          this.$vuetify.theme.themes.light.primary =
            params.formParams.themeColor;
          this.isLoading = false;
          this.dataLoaded = true;
        })
        .catch((error) => {
          this.error = error.ExceptionMessage;
          this.isLoading = false;
        });
    },
    methods: {
      ...mapActions(['setParams', 'setCampaignSlug']),
    },
    render(createElement) {
      return createElement(component, {
        props: {
          isLoading: this.isLoading,
          dataLoaded: this.dataLoaded,
          error: this.error,
        },
      });
    },
  });
};

export default withFormParams;
